export interface TableRowType{
    status: string;
    id: number;
    seriesTitle: string;
    contentType?: string;
    episodeNumber?: number;
    displayTitle?: string;
    seasonNumber?: number;
    title: string;
    feed: {
        ingestConfig: {
            ingestType: string,
            labPartner: string,
        }
    };
}

export interface FormattedRowType {
    id: number;
    contentItemType: string;
    status: string;
    startDate: string;
    finishDate: string;
    title: string;
    seriesTitle: string;
    number?: number,
    displayTitle?: string;
    seasonNumber?: number,
    contentPartner: {
        partnerName: string;
    };
}

export interface DeliverySummaryResponse {
    COMPLETE: number;
    FAILED: number;
    IN_PROGRESS: number;
    PENDING: number;
}

export interface DeliveryManagerState extends DeliverySummaryResponse {
    isLoading: boolean;
    total: number;
    rows: [
        {
            id: number;
            status: string;
            startDate: string;
            finishDate: string;
            title: string;
            seriesTitle: string;
            contentType: string;
            contentPartner: string;
        }
    ];
}

export enum DeliverySectionTitles {
    Pending = 'Pending',
    InProgress = 'In Progress',
    Failed = 'Failed',
    CompleteTwo = 'Completed last 2 weeks',
}
export interface QueryParams {
    contentItemType: string[];
    contentPartnerId: string[];
    startDateEnd: string;
    startDateStart: string;
    finishDateEnd: string;
    finishDateStart: string;
    limit: number;
    offset: number;
    qcJobAssigneeId: number[];
    qcJobStatus: string[];
    qcJobType: string;
    sortBy: string;
    sortOrder: string;
    title: string;
}

export enum DeliveryStatusEnum {
    InProgress = 'IN_PROGRESS',
    Pending = 'PENDING',
    Failed = 'FAILED',
    Complete = 'COMPLETE',
    Canceled = 'CANCELED',
    Ready = 'READY',
}
